import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import ProductWrapper from '../../components/Product/ProductWrapper';
import ShareButton from '../../components/ShareButton/ShareButton';
import Masonry from 'react-masonry-css';
import { ClipLoader } from 'react-spinners';
import './Catolog.css';

function Catalog() {
    const { id } = useParams();
    const [productos, setProductos] = useState([]);
    const [provider, setProvider] = useState({});
    const [loading, setLoading] = useState(true);

    // Configuración de breakpoints para Masonry
    const breakpointColumnsObj = {
        default: 6,
        1600: 6,
        1200: 5,
        768: 3,
        480: 2
    };

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                // Obtener todos los productos del proveedor
                const res = await fetch(`https://api.minymol.com/products/by-provider/${id}`);
                const resIds = await res.json();

                const ids = resIds.map(p => p.product_id).filter(Boolean);


                if (ids.length === 0) {
                    setProductos([]);
                    return;
                }

                // Obtener las vistas previas de los productos
                const previewsRes = await fetch('https://api.minymol.com/products/previews', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ids }),
                });

                const previews = await previewsRes.json();
                const activos = previews.filter(p => !p.isInactive);
                setProductos(activos);

                // Obtener info del proveedor
                const providerRes = await fetch(`https://api.minymol.com/providers/public/${id}`);
                const providerData = await providerRes.json();
                setProvider(providerData);
            } catch (err) {
                console.error('Error al cargar el catálogo del proveedor:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchCatalog();
    }, [id]);

    return (
        <div className="catalog-container">
            <div style={{ marginTop: '15px'}} className='logo-provider'>
                <img src={provider.banner_url || '/logoSup.webp'} alt="Logo del proveedor" />
            </div>

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh', width: '100%' }}>
                    <ClipLoader color="#fa7e17" size={30} />
                </div>
            ) : (
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="products-cont masonry-grid"
                    columnClassName="masonry-grid_column"
                >
                    {productos.map((prod, index) => (
                        <ProductWrapper key={`wrapper-${index}`} product={prod} index={index} />
                    ))}
                </Masonry>
            )}

            {productos.length > 0 && (
                <ShareButton
                    title={`Catálogo de ${provider.nombre_empresa}`}
                    imageUrl={provider.logo_url || 'https://cdn.minymol.com/uploads/logoblanco.webp'}
                    isCatalogo={true}
                />
            )}

            <NavInf />
            <Footer />
        </div>
    );
}

export default Catalog;
